/* eslint-disable no-cond-assign,no-eval */

export const parseJson = (txt, val) => {
    try {
        return JSON.parse(txt)
    } catch(x) {
        return val
    }
}

export const evalJson = (txt, val) => {
    if (!txt) return val

    try {
        return eval(txt)
    } catch(x) {
        return val
    }
}


export const parseStringBlocks = (str, {
    left='{', right='}', mergeTokens=true
} = {}) => {
    let blockRegex = new RegExp(left + '|' + right, 'ig')
    let leftRegex = new RegExp(left, 'i')
    let blocks = []
    var depth, pos, match

    do {
        depth = 0
        while (match = blockRegex.exec(str)) {

            if (leftRegex.test(match[0])) {
                if (!depth) {
                    pos = blockRegex.lastIndex
                }
                depth++
                continue
            }

            if (!depth) continue

            depth--
            if (!depth) {
                blocks.push(str.slice(pos, match.index))
            }
        }
    } while (depth && (blockRegex.lastIndex = pos))

    return mergeTokens
       ? blocks.map(a => left + a + right)
       : blocks
}


export const parseHtml = str =>
    (str || '')
    .replaceAll('&quot;', '"')
    .replace(/(&#(\d+);)/g, (_, __, charCode) => String.fromCharCode(charCode))
    .replaceAll('&lt;', '<')
    .replaceAll('&gt;', '>')
    .replaceAll('&amp;', '&')



// WEBPACK FOOTER //
// ./src/twd/parse.js